import { useFeatureLoyaltyMyCodeContentQuery } from 'generated/sanity-graphql';

const FEATURE_LOYALTY_MY_CODE_SINGLETON_ID = 'my-code-singleton';

export const useLoyaltyMyCode = () => {
  const { data, loading } = useFeatureLoyaltyMyCodeContentQuery({
    variables: { featureMyCodeId: FEATURE_LOYALTY_MY_CODE_SINGLETON_ID },
    fetchPolicy: 'cache-and-network',
  });

  return {
    data: data?.MyCode,
    loading,
  };
};
